<template>
<v-container>
    <v-card class="my-5 pa-4 pb-0 pt-0" flat>
        <v-row v-if="!isShow" align="center" class="mb-4">
            <v-col cols="7">
                <v-img max-width="200" src="/images/logo1.png" lazy-src="/images/logo1.png" aspect-ratio="6" contain>
                    <template v-slot:placeholder>
                        <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-row>
                    </template>
                </v-img>
            </v-col>
            <v-col cols="5" class="d-flex justify-end">
                <v-btn to="/register" class="primary">
                    Register
                </v-btn>
            </v-col>
        </v-row>
        <v-list class="py-0">
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="headline font-weight-regular primary--text">Test Result</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon class="grey--text">
                    <v-icon color="primary">mdi-clock-outline</v-icon>
                    <span class="ml-2">{{dateTime(test.createdAt)}}</span>
                </v-list-item-icon>
            </v-list-item>
        </v-list>
        <v-divider color="yellow"></v-divider>
        <v-row>
            <v-col cols="12" class="my-0 mt-3 py-0">
                <v-card class="px-4" flat>
                    <v-row>
                        <v-col cols="12">
                            <div class="font-weight-bold mb-2">Offer URL:</div>
                            <v-icon>mdi-open-in-new</v-icon> <a :href="test.test_url" target="_blank">{{ test.test_url }}</a>
                        </v-col>
                        <v-col cols="12">
                            <div class="font-weight-bold mb-2">Destination URL:</div>
                            <v-icon>mdi-open-in-new</v-icon> <a :href="test.final_url" target="_blank">{{ test.final_url }}</a>
                        </v-col>
                    </v-row>
                    <v-card class="px-4 grey lighten-5" flat>
                        <v-row>
                            <v-col cols="12" md="6">
                                <table class="body-1 page-user-view">
                                    <tr>
                                        <td class="font-weight-bold">Device:</td>
                                        <td>
                                            <v-icon v-if="test.os_device == 'android_phone'" class="green--text text--darken-2">mdi-android</v-icon>
                                            <v-icon v-else-if="test.os_device == 'android_tablet'" class="grey--text text--darken-2">mdi-tablet</v-icon>
                                            <v-icon v-else-if="test.os_device == 'ios_iphone'" class="grey--text text--darken-2">mdi-apple</v-icon>
                                            <v-icon v-else-if="test.os_device == 'ios_ipad'" class="grey--text text--darken-2">mdi-tablet-ipad</v-icon>
                                            <v-icon v-else class="light-blue--text text--darken-2">mdi-microsoft-windows</v-icon>
                                            <span class="ml-2">{{test.os_device == 'android_phone' ? 'Android' : test.os_device == 'android_tablet' ? 'Tablet (Android)' : test.os_device == 'ios_iphone' ? 'iPhone (IOS)' : test.os_device == 'ios_ipad' ? 'iPad (IOS)' : 'Windows'}} {{test.os_version}}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Country:</td>
                                        <td><span :class="`flag-icon flag-icon-${test.country.toLowerCase()} mr-2`"></span>{{ test.country }}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Hops:</td>
                                        <td>
                                            <v-chip class="white" label small color="primary" dark>
                                                {{test.hops}}
                                            </v-chip>
                                        </td>
                                    </tr>
                                </table>
                            </v-col>
                            <v-col cols="12" md="6">
                                <table class="body-1 page-user-view">
                                    <tr>
                                        <td class="font-weight-bold">Status:</td>
                                        <td>
                                            <div>
                                                <v-chip small :color="test.final_status <= 300 ? 'green' : test.final_status <= 400 ? 'blue' : test.final_status <= 500 ? 'orange' : test.final_status <= 600 ? 'red': ''" label text-color="white">
                                                    <v-icon size="15" left>mdi-checkbox-marked-circle-outline</v-icon>
                                                    {{test.final_status}}
                                                </v-chip>
                                                <v-tooltip left>
                                                    <template v-slot:activator="{ on, attrs }"><i class="px-2 mdi mdi-information-outline" v-bind="attrs" v-on="on"></i></template>
                                                    <span>{{`${errorsMessage[test.final_status] ? errorsMessage[test.final_status] : 'Something went wrong.'}`}}</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold">Time:</td>
                                        <td>
                                            {{Math.round(test.total_ms / 1000)}} .sec
                                        </td>
                                    </tr>
                                </table>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-card>
            </v-col>
        </v-row>

        <div class="pa-10 pt-4 pl-0">
            <v-snackbar v-model="snackbar" :timeout="2000" bottom right>
                Copied
                <v-btn color="primary" text @click="snackbar = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-snackbar>
            <v-dialog v-model="dialog" max-width="600px">
                <v-card>
                    <v-icon class="close-btn" @click="dialog = false">mdi-close</v-icon>
                    <v-card-title>
                        <span class="headline">Share with others</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-clipboard:copy="shareLink" v-clipboard:success="onCopy" v-clipboard:error="onError" :value="shareLink" label="Copy link" append-icon="mdi-content-copy" dense outlined></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-timeline class="list" transition="scroll-y-transition" v-for="item in offers" :key="item.url" dense>
                <v-timeline-item :color="item.status <= 300 ? 'green' : item.status <= 400 ? 'blue' : item.status <= 500 ? 'orange' : item.status <= 600 ? 'red': ''" large>
                    <template v-slot:icon>
                        <span class="white--text font-weight-bold">{{ item.status }}</span>
                    </template>
                    <v-card color="grey lighten-4" class="elevation-0">
                        <v-card-text>
                            {{ item.url }}
                        </v-card-text>
                    </v-card>
                </v-timeline-item>
                <v-timeline-item v-if="item.time" class="pa-0 last" icon="mdi-clock" :color="item.status <= 300 ? 'green' : item.status <= 400 ? 'blue' : item.status <= 500 ? 'orange' : item.status <= 600 ? 'red': ''">
                    <v-card width="80" class="elevation-1 position-left-time">
                        <v-card-text class="pa-1">
                            {{ item.time }} ms
                        </v-card-text>
                    </v-card>
                </v-timeline-item>
            </v-timeline>
            <div class="d-flex justify-center">
                <v-btn @click="share" v-if="isShow" :loading="loading" class="primary">
                    <v-icon left>mdi-share-variant</v-icon>
                    Share
                </v-btn>
            </div>
        </div>
        <hr class="mt-3"/>
        <div>
            <p style="margin-top: 22px; font-size: 40px; text-align: center;">Can be optimized</p>
            <v-card class="mx-auto" max-width="650">
                <v-card-text style="display: flex; justify-content: center; padding: 0; padding-top: 20px;">
                    <!-- <div>Can auto test</div> -->
                    <div class="text--primary mr-3 my-4">
                        <v-icon style="font-size: 43px;">mdi mdi-flash-auto</v-icon>                        
                    </div>
                    <p class="text-h6 text--primary mt-4" style="font-size: 27px !important;">
                        Can auto test 1000 links <v-icon>mdi-link-variant</v-icon> in 120 seconds.
                    </p>
                </v-card-text>
                <v-card-actions style="display: flex; justify-content: center;">
                    <v-btn class="primary mb-4" to="/plans">
                         Optimize now
                    </v-btn>
                </v-card-actions>
            </v-card>
        </div>
    </v-card>
</v-container>
</template>

<script>
import VueClipboard from 'vue-clipboard2'
import Vue from 'vue'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
import {
    mapMutations,
    mapActions,
    mapGetters
} from 'vuex'
import moment from 'moment'
export default {
    props: ['offers', 'test', 'isShow'],
    data() {
        return {
            dialog: false,
            snackbar: false,
            shareLink: '',
            loading: false,
            errorsMessage: {
                200: "success",
                301: "Permanent redirect",
                302: "Found",
                404: "Not Found",
                410: "Gone",
                451: "Unavailable for legal reasons",
                500: "Internal server error",
                502: "Bad Gateway",
                503: "Service unavailable",
                504: "Service unavailable"
            }
        }
    },
    computed: {
        ...mapGetters(['userAccount'])
    },
    methods: {
        ...mapActions(['GetResponse', 'TrackEvents']),
        ...mapMutations(['SnackbarSuccess']),
        onCopy(e) {
            let dataMsg = { success: true, message: 'Copy Successfully', action: 'success' }
            this.SnackbarSuccess(dataMsg)
        },
        onError(e) {
            let dataMsg = { success: true, message: 'Copy ' + e.text, action: 'error' }
            this.SnackbarSuccess(dataMsg)
        },
        dateTime(date) {
            return moment(date).format('MMMM Do YYYY h:mm a');
        },
        async share() {
            this.loading = true
            try {
                let url = `/internal/v2/share/${this.test._id}`
                const data = (await this.GetResponse(url)).data
                if (data.success) {
                    this.shareLink = data.data.link
                    this.loading = false
                    this.dialog = true
                    let dataMsg = { success: true, message: data.message, action: 'success' }
                    this.SnackbarSuccess(dataMsg)
                    this.$root.$emit("progressUpdate", 'shareLink', 100);
                    this.TrackEvents({ event_name: 'linktest', action: "share" })
                } else {
                    this.loading = false
                    let dataMsg = { success: true, message: data.message, action: 'success' }
                    this.SnackbarSuccess(dataMsg)
                }
            } catch (err) {
                this.loading = false
                let dataMsg = { success: true, message: err.response.data.errors[0].message, action: 'error' }
                this.SnackbarSuccess(dataMsg)
            }
        }
    }
}
</script>

<style>
.td-circular {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.circular {
    background: #039be5;
    text-align: center;
    line-height: 1;
    border: none;
    color: white;
    border-radius: 50px;
    height: 60px;
    width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    word-break: break-all;
}

.position-left-time {
    left: -15px;
    top: 4px;
}

.list.last:last-child {
    display: none !important
}
</style>
